<template>
  <div class="radio-wrap">
    <slot name="title"></slot>
    <div class="group">
      <div
        class="radio"
        v-for="(item, idx) in data"
        :key="idx"
        @click.stop="handleClick(item)"
      >
        <img :src="getPic(item)" />
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    data: {
      type: Array,
      default: () => [],
      required: true
    },
    value: {
      type: String,
      default: ""
    }
  },
  methods: {
    getPic(item) {
      return item.value === this.value
        ? "https://assets.rurushishi.com/yq-rs-make/huafa/img/radio-select.png"
        : "https://assets.rurushishi.com/yq-rs-make/huafa/img/radio.png";
    },
    handleClick(item) {
      this.$emit("change", item.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-wrap {
  display: flex;
  align-items: center;
  font-size: 0.3rem;
  color: #222222;
  flex: 1;
  .group {
    flex: 1;
    display: flex;
    align-items: center;
    margin-left: 0.6rem;
    .radio {
      display: flex;
      align-items: center;
      &:not(:first-child) {
        margin-left: 0.6rem;
      }
      & > img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.12rem;
      }
    }
  }
}
</style>
